const COLORS = {
  main: '#5542F6',
  lightGrey: '#fbfafa',
  success: '#42C293',
  danger: '#fc3400',
  grey: '#84818a',
  black: '#2e2c34',
  border: '#ebeaed'
};

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.default = COLORS;
